import { Lozingsvorm, Relatie } from '@/lib/types/relatie';

export const groundDischargeMessage = 'U heeft eerder aangegeven geen lozing te hebben, u rapporteert wel een lozing, vul in wat juist is.';
export const groundReuseMessage =
  'U heeft eerder aangegeven geen drainagesysteem te hebben, u rapporteert wel hergebruik van drainagewater, vul in wat juist is.';

export function getGroundDischargeError(vorm: number | undefined, volume: number | null | undefined): string | undefined {
  if (
    volume != null &&
    volume > 0 &&
    [Lozingsvorm.GeenLozing, Lozingsvorm.GeenDrainagesysteem, Lozingsvorm.WatergiftAfgestemd, Lozingsvorm.DrainagesysteemNietInGebruik].some(
      value => value === vorm
    )
  ) {
    return groundDischargeMessage;
  }
}

export function getGroundReuseError(vorm: number | undefined, volume: number | null | undefined): string | undefined {
  if (volume != null && volume > 0 && (vorm === Lozingsvorm.GeenDrainagesysteem || vorm === Lozingsvorm.DrainagesysteemNietInGebruik)) {
    return groundReuseMessage;
  }
}

export interface GroundWaterError {
  name: ['lozingen'] | ['lozingen', number, 'lozingen', number, keyof Relatie['lozingen'][number]['lozingen'][number]];
  errors: string[];
}

type GroundWaterReport = Partial<Pick<Relatie, 'registratiejaar' | 'teeltwijze' | 'lozingsVorm' | 'lozingen'>>;

export function getGroundWaterErrors(relatie: GroundWaterReport): GroundWaterError[] {
  if (!(Number(relatie.registratiejaar) >= 2026) || ![0, 2].some(value => value === relatie.teeltwijze)) return [];

  const groupIndex = relatie.lozingen?.findIndex(group => group?.betrekkingTotTeeltwijze === 0) ?? -1;
  if (groupIndex === -1) {
    return [{ name: ['lozingen'], errors: ['Vul de lozingen, het toegediend voedingswater en het hergebruikt drainagewater voor grondteelt in.'] }];
  }

  const vorm = relatie.lozingsVorm?.find(group => group?.betrekkingTotTeeltwijze === 0)?.value;
  const rows = relatie.lozingen![groupIndex].lozingen;
  const errors: GroundWaterError[] = [];
  for (let index = 0; index < 13; index++) {
    const row = rows[index];
    const addError = (field: keyof Relatie['lozingen'][number]['lozingen'][number], message: string) =>
      errors.push({ name: ['lozingen', groupIndex, 'lozingen', index, field], errors: [message] });
    for (const field of ['toegediendVoedingswaterHoeveelheid', 'hergebruiktDrainagewaterHoeveelheid'] as const) {
      if (row?.[field] == null)
        addError(
          field,
          `Vul ${field === 'toegediendVoedingswaterHoeveelheid' ? 'toegediend voedingswater' : 'hergebruikt drainagewater'} in voor periode ${index + 1}. Vul 0 in als geen volume van toepassing is.`
        );
    }
    const requiredDischarge = Number(relatie.registratiejaar) >= 2027 ? 'hoeveelheidOppervlaktewater' : 'hoeveelheid';
    if (row?.[requiredDischarge] == null)
      addError(requiredDischarge, `Vul de lozing hoeveelheid in voor periode ${index + 1}. Vul 0 in als geen volume van toepassing is.`);
    for (const field of ['hoeveelheid', 'hoeveelheidRiool', 'hoeveelheidOppervlaktewater'] as const) {
      const message = getGroundDischargeError(vorm, row?.[field]);
      if (message) addError(field, message);
    }
    const message = getGroundReuseError(vorm, row?.hergebruiktDrainagewaterHoeveelheid);
    if (message) addError('hergebruiktDrainagewaterHoeveelheid', message);
  }
  return errors;
}
